"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InplaceEditor = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_text_1 = require("@hopin-team/ui-text");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var root_1 = require("./styled/root");

var InplaceEditor = function InplaceEditor(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      _b = _a["aria-label"],
      ariaLabel = _b === void 0 ? 'inplace-editor-input' : _b,
      element = _a.element,
      _c = _a.maxCount,
      maxCount = _c === void 0 ? 25 : _c,
      maxLengthMessage = _a.maxLengthMessage,
      value = _a.value,
      handleInputChange = _a.handleInputChange,
      isTitle = _a.isTitle,
      isNumber = _a.isNumber,
      min = _a.min,
      max = _a.max,
      readOnly = _a.readOnly,
      maxLines = _a.maxLines,
      setIsEditing = _a.setIsEditing;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'InplaceEditor',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _d = tslib_1.__read((0, react_1.useState)(false), 2),
      isEditMode = _d[0],
      setIsEditMode = _d[1];

  var _e = tslib_1.__read((0, react_1.useState)(value.current), 2),
      inputValue = _e[0],
      setInputValue = _e[1];

  var inputReference = (0, react_1.useRef)(null);
  var isReadOnly = readOnly || !handleInputChange;
  var handleSubmit = (0, react_1.useCallback)(function () {
    handleInputChange && handleInputChange(inputValue);
    setIsEditMode(false);
  }, [handleInputChange, setIsEditMode, inputValue]);
  (0, react_1.useEffect)(function () {
    var _a;

    if (isEditMode) {
      (_a = inputReference.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [isEditMode, inputReference]);
  (0, react_1.useEffect)(function () {
    setInputValue(value.current);
  }, [setInputValue, value]);
  (0, react_1.useEffect)(function () {
    if (setIsEditing) {
      setIsEditing(isEditMode);
    }
  }, [isEditMode, setIsEditing]);
  var maxLengthMessageId = (0, use_id_1.useId)();
  return react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID
  }, !isReadOnly && isEditMode ? react_1.default.createElement(root_1.InputContainer, {
    element: element
  }, react_1.default.createElement(root_1.TextInput, {
    "aria-label": ariaLabel,
    "aria-describedby": maxLengthMessageId,
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && handleSubmit();
    },
    ref: inputReference,
    onBlur: handleSubmit,
    maxLength: maxCount,
    isTitle: isTitle,
    min: min,
    max: max,
    type: isNumber ? 'number' : 'text',
    value: inputValue,
    onChange: function onChange(event) {
      return setInputValue(event.target.value);
    }
  }), react_1.default.createElement("div", {
    id: maxLengthMessageId,
    "aria-live": "assertive",
    "aria-relevant": "text removals"
  }, maxLengthMessage && inputValue.length >= maxCount && react_1.default.createElement(ui_text_1.Text, {
    pattern: "caption",
    mb: 0.5
  }, maxLengthMessage))) : react_1.default.createElement(root_1.InputContainer, {
    element: element,
    onClick: isReadOnly ? undefined : function () {
      return setIsEditMode(true);
    },
    isTitle: isTitle,
    readOnly: isReadOnly,
    lineclamp: maxLines,
    title: inputValue
  }, inputValue));
};

var InplaceEditorWithSpace = (0, ui_helper_with_space_1.withSpace)(InplaceEditor);
exports.InplaceEditor = InplaceEditorWithSpace;